import { useState, useEffect } from "react";
import { Copy } from "lucide-react";

const fullCode = `<script src="https://cdn.botsweep.com/bs.js"
  data-site="YOUR_SITE_ID" async></script>`;

const TypingTerminal = ({ inView }: { inView: boolean }) => {
  const [typed, setTyped] = useState("");
  const [copied, setCopied] = useState(false);
  const [doneTyping, setDoneTyping] = useState(false);

  useEffect(() => {
    if (!inView) return;
    let i = 0;
    const interval = setInterval(() => {
      i++;
      setTyped(fullCode.slice(0, i));
      if (i >= fullCode.length) {
        clearInterval(interval);
        setDoneTyping(true);
      }
    }, 30);
    return () => clearInterval(interval);
  }, [inView]);

  const handleCopy = () => {
    navigator.clipboard.writeText(fullCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative rounded-xl overflow-hidden border border-border bg-background shadow-2xl">
      {/* Terminal header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-border/50 bg-surface/80">
        <div className="flex items-center gap-2">
          <span className="w-3 h-3 rounded-full bg-destructive/80" />
          <span className="w-3 h-3 rounded-full bg-amber/80" />
          <span className="w-3 h-3 rounded-full bg-green/80" />
          <span className="ml-3 text-[10px] font-mono text-muted-foreground tracking-wider">terminal</span>
        </div>
        <button
          onClick={handleCopy}
          className="flex items-center gap-1.5 text-[10px] font-mono text-muted-foreground hover:text-primary transition-colors"
        >
          <Copy className="w-3.5 h-3.5" />
          <span aria-live="polite">{copied ? "Copied!" : "Copy"}</span>
        </button>
      </div>

      {/* Scanlines overlay */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
        background: "repeating-linear-gradient(0deg, transparent, transparent 2px, hsl(var(--foreground) / 0.1) 2px, hsl(var(--foreground) / 0.1) 4px)"
      }} />

      {/* Code area */}
      <pre className="p-6 md:p-8 overflow-x-auto min-h-[120px]">
        <code className="text-sm md:text-base font-mono text-primary/90 leading-relaxed whitespace-pre-wrap">
          {typed}
        </code>
        {!doneTyping && (
          <span className="inline-block w-2 h-5 bg-green ml-0.5 animate-pulse-glow" />
        )}
        {doneTyping && (
          <span className="inline-block w-2 h-5 bg-green ml-0.5 animate-pulse-glow opacity-60" />
        )}
      </pre>
    </div>
  );
};

export default TypingTerminal;
